import TemplateColors from './TemplateColors';

const TemplateDarkColorDefaultValues = {
  [TemplateColors.FIELD_BACKGROUND]: '#464D5C',
  [TemplateColors.HEADER_BACKGROUND]: '#272b35',
  [TemplateColors.HEADER_FONT]: '#ffffff',
  [TemplateColors.TEXT_FONT]: '#ffffff',
};

export default TemplateDarkColorDefaultValues;
